import './ProgressBarComponent.scss';

interface IProgressBarComponentProps {
    progress: number;
    height?: number;
}

const ProgressBarComponent = (props: IProgressBarComponentProps) => {
    const {progress} = props;
    const clampedProgress = Math.min(100, Math.max(0, progress));


    const height = props.height || 16;

    return (
        <div className="progress-bar-container" style={{height: `${height}px`}}>
            <div
                className={`progress-bar-fill ${clampedProgress === 100 ? 'full-progress' : ''}`}
                style={{width: `${clampedProgress}%`, height: "100%"}}
            ></div>
        </div>
    )
}
export default ProgressBarComponent;
